(() => {
  const canvas = document.getElementById("pole-bg");
  if (!canvas) return;

  const hero = canvas.closest(".pole-hero");
  const vh = hero?.dataset?.vh;
  if (vh) hero.style.setProperty("--pole-hero-vh", `${vh}vh`);

  const ctx = canvas.getContext("2d", { alpha: true });
  const DPR = Math.min(2, window.devicePixelRatio || 1);

  const state = { t: 0, blobs: [], dust: [], maxDust: 120 };

  const rand = (a, b) => a + Math.random() * (b - a);

  function resize() {
    const r = canvas.getBoundingClientRect();
    canvas.width = Math.floor(r.width * DPR);
    canvas.height = Math.floor(r.height * DPR);
    ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
  }

  function init() {
    resize();
    const r = canvas.getBoundingClientRect();

    // Неоновые “прожекторы” (под пилон: сверху + боковые)
    state.blobs = [
      { x: rand(0.40, 0.60), y: rand(0.06, 0.14), r: 620, hue: 280 }, // верхний прожектор
      { x: rand(0.12, 0.28), y: rand(0.30, 0.55), r: 520, hue: 320 }, // левый
      { x: rand(0.68, 0.88), y: rand(0.45, 0.75), r: 520, hue: 200 }  // правый
    ];

    state.dust = Array.from({ length: state.maxDust }, () => ({
      x: Math.random() * r.width,
      y: Math.random() * r.height,
      vx: rand(-0.08, 0.08),
      vy: rand(0.02, 0.18),
      a: rand(0.04, 0.12),
      s: rand(0.6, 1.8)
    }));
  }

  function drawBlob(px, py, radius, hue, alpha) {
    const g = ctx.createRadialGradient(px, py, 0, px, py, radius);
    g.addColorStop(0, `hsla(${hue}, 95%, 62%, ${alpha})`);
    g.addColorStop(0.6, `hsla(${hue}, 95%, 55%, ${alpha * 0.35})`);
    g.addColorStop(1, `hsla(${hue}, 95%, 50%, 0)`);
    ctx.fillStyle = g;
    ctx.beginPath();
    ctx.arc(px, py, radius, 0, Math.PI * 2);
    ctx.fill();
  }

  let rafId = null;

  function frame() {
    const r = canvas.getBoundingClientRect();
    ctx.clearRect(0, 0, r.width, r.height);

    // фон
    const bg = ctx.createLinearGradient(0, 0, r.width, r.height);
    bg.addColorStop(0, "#05060a");
    bg.addColorStop(1, "#080a12");
    ctx.fillStyle = bg;
    ctx.fillRect(0, 0, r.width, r.height);

    // неон (additive)
    ctx.globalCompositeOperation = "lighter";
    state.t += 0.016;

    state.blobs.forEach((b, i) => {
      const wobX = Math.sin(state.t * (0.7 + i * 0.18)) * 0.05;
      const wobY = Math.cos(state.t * (0.6 + i * 0.14)) * 0.04;
      const px = (b.x + wobX) * r.width;
      const py = (b.y + wobY) * r.height;
      drawBlob(px, py, b.r, b.hue, 0.22);
    });

    // пыль в прожекторах
    ctx.globalCompositeOperation = "screen";
    ctx.fillStyle = "rgba(255,255,255,0.08)";
    for (const d of state.dust) {
      d.x += d.vx; d.y += d.vy;

      if (d.y > r.height + 10) { d.y = -10; d.x = Math.random() * r.width; }
      if (d.x < -10) d.x = r.width + 10;
      if (d.x > r.width + 10) d.x = -10;

      ctx.globalAlpha = d.a;
      ctx.beginPath();
      ctx.arc(d.x, d.y, d.s, 0, Math.PI * 2);
      ctx.fill();
    }
    ctx.globalAlpha = 1;

    // лёгкий шум
    ctx.globalCompositeOperation = "overlay";
    ctx.fillStyle = "rgba(255,255,255,0.03)";
    for (let i = 0; i < 260; i++) {
      ctx.fillRect(Math.random() * r.width, Math.random() * r.height, 1, 1);
    }

    ctx.globalCompositeOperation = "source-over";
    rafId = requestAnimationFrame(frame);
  }

  // экономия: стоп когда не видно
  const io = new IntersectionObserver((entries) => {
    const on = entries[0]?.isIntersecting;
    if (on && !rafId) frame();
    if (!on && rafId) { cancelAnimationFrame(rafId); rafId = null; }
  }, { threshold: 0.1 });

  init();
  window.addEventListener("resize", init, { passive: true });
  io.observe(hero);
})();